import { Injectable } from '@angular/core';
import { CONSTANTS } from './config.service';
import { GeowatcherService } from './geowatcher.service';
import { LoggerService } from './logger.service';
import { PubSubService } from './pub-sub.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class BadgeService {
  constructor(
    private pubSub: PubSubService,
    private geowatcher: GeowatcherService,
    private logger: LoggerService
  ) {
    this.logger.log('Badge constructor - subscribing to events surveyRestarted and surveyFinished', MSRemoteLoggerCategory.BADGE_SERVICE);
    this.pubSub.subscribe(CONSTANTS.EVENTS.surveyRestarted, (...args) => {
      this.updateBadge();
    });
    this.pubSub.subscribe(CONSTANTS.EVENTS.surveyFinished, (...args) => {
      this.updateBadge();
    });
  }

  updateBadge() {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.geowatcher.setBadge();
  }

  initialize() {
    this.updateBadge();
  }
}
